import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

/**
 * 🔍 Optimized Search Bar
 * - Debounced live search
 * - Controlled input
 * - Clear button
 * - Mobile friendly
 */
export default function SearchBar({
  value = "",
  onChange,
  delay = 300,
}) {
  const [text, setText] = useState(value);

  // 🔁 Sync external value (when cleared from parent)
  useEffect(() => {
    setText(value);
  }, [value]);

  // ⚡ Debounced search
  useEffect(() => {
    const handler = setTimeout(() => {
      onChange(text);
    }, delay);

    return () => clearTimeout(handler);
  }, [text, delay, onChange]);

  return (
    <div className="mb-6 w-full">
      <div className="relative max-w-md mx-auto md:mx-0">

        {/* 🔍 SEARCH ICON */}
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-400 w-4 h-4" />

        {/* INPUT */}
        <input
          type="text"
          placeholder="Search handmade items..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="
            w-full
            pl-10 pr-10
            py-2.5
            rounded-full
            border
            border-pink-200
            bg-white/70
            text-sm
            focus:outline-none
            focus:ring-2
            focus:ring-pink-300
            transition
          "
        />

        {/* ❌ CLEAR BUTTON */}
        {text && (
          <button
            onClick={() => setText("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-pink-400 hover:text-pink-600 transition"
            aria-label="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
